export const centederViewOnContent = (id: string) => {
  const interval = setInterval(() => {
    console.log("interval");
    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      clearInterval(interval);
    }
  }, 30);

  return () => clearInterval(interval);
};
